import React, { useState } from "react";
import {
  FaUser,
  FaEnvelope,
  FaLock,
  FaPhone,
  FaEye,
  FaEyeSlash,
  FaGraduationCap,
  FaBookOpen
} from "react-icons/fa";
import { FcGoogle } from "react-icons/fc";
import { auth, googleProvider, db } from "../firebase";
import {
  createUserWithEmailAndPassword,
  signInWithPopup,
  updateProfile
} from "firebase/auth";
import { doc, setDoc, getDoc } from "firebase/firestore";
import { useNavigate } from "react-router-dom";
import { track } from "@vercel/analytics";
import { ensureCompleteUserDocument } from '../utils/userHelpers';
import styles from "./Signup.module.css";

import SocialSidebar from "../components/SocialSideBar";

const Signup = () => {
  const [username, setUsername] = useState("");
  const [email, setEmail] = useState("");
  const [mobile, setMobile] = useState("");
  const [className, setClassName] = useState("");
  const [preparingFor, setPreparingFor] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const navigate = useNavigate();

  const handleSignup = async (e) => {
    e.preventDefault();
    track("signup_email_submit", { page: window.location.pathname, email });

    if (password !== confirmPassword) {
      alert("Passwords do not match");
      return;
    }
    try {
      const userCredential = await createUserWithEmailAndPassword(auth, email, password);
      const user = userCredential.user;

      await updateProfile(user, { displayName: username });

      // Create complete user document with ALL required fields
      await ensureCompleteUserDocument(user, {
        username,
        mobile,
        class: className,
        preparingFor,
      });

      await user.sendEmailVerification();
      alert("Signup successful! A verification link has been sent to your email.");
      navigate("/login");
    } catch (error) {
      alert(error.message);
    }
  };

  const handleGoogleSignup = async () => {
    track("signup_google_click", { page: window.location.pathname });
    try {
      const result = await signInWithPopup(auth, googleProvider);
      const user = result.user;
      
      // Ensure complete user document with ALL required fields
      await ensureCompleteUserDocument(user);
      
      navigate("/");
    } catch (error) {
      alert(error.message);
    }
  };

  return (
    <div className={styles.signupContainer}>
      <SocialSidebar />
      <div className={styles.signupWrapper}>
        <div className={styles.signupBox}>
          <div className={styles.headerArea}>
            <h1 className={styles.brandName}>PrrepX Pathshala</h1>
            <h2 className={styles.tagline}>Create Your Account</h2>
            <p className={styles.subTagline}>Join the elite community of future IITians & Doctors.</p>
          </div>

          <button onClick={handleGoogleSignup} className={styles.googleBtn}>
            <FcGoogle className={styles.googleIcon} /> 
            <span>Sign up with Google</span>
          </button>

          <div className={styles.divider}>
            <span>or join with email</span>
          </div>

          <form onSubmit={handleSignup} className={styles.formGrid}>
            <div className={styles.inputGroup}>
              <FaUser className={styles.icon} />
              <input
                type="text"
                placeholder="Full Name"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                required
              />
            </div>

            <div className={styles.inputGroup}>
              <FaPhone className={styles.icon} />
              <input
                type="tel"
                placeholder="Mobile Number"
                value={mobile}
                onChange={(e) => setMobile(e.target.value)}
                required
              />
            </div>

            <div className={styles.selectionRow}>
              <div className={styles.inputGroup}>
                <FaGraduationCap className={styles.icon} />
                <select
                  value={className}
                  onChange={(e) => setClassName(e.target.value)}
                  required
                  className={styles.customSelect}
                >
                  <option value="" disabled hidden>Select Class</option>
                  {["6", "7", "8", "9", "10", "11", "12", "Dropper"].map(c => (
                    <option key={c} value={c}>Class {c}</option>
                  ))}
                </select>
              </div>

              <div className={styles.inputGroup}>
                <FaBookOpen className={styles.icon} />
                <select
                  value={preparingFor}
                  onChange={(e) => setPreparingFor(e.target.value)}
                  required
                  className={styles.customSelect}
                >
                  <option value="" disabled hidden>Target Exam</option>
                  <option value="School">School</option>
                  <option value="Boards">Boards</option>
                  <option value="JEE">JEE</option>
                  <option value="NEET">NEET</option>
                </select>
              </div>
            </div>

            <div className={styles.inputGroup}>
              <FaEnvelope className={styles.icon} />
              <input
                type="email"
                placeholder="Email Address"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>

            <div className={styles.passwordRow}>
              <div className={`${styles.inputGroup} ${styles.passwordField}`}>
                <FaLock className={styles.icon} />
                <input
                  type={showPassword ? "text" : "password"}
                  placeholder="Password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                />
                <span className={styles.eyeIcon} onClick={() => setShowPassword(!showPassword)}>
                  {showPassword ? <FaEyeSlash /> : <FaEye />}
                </span>
              </div>

              <div className={`${styles.inputGroup} ${styles.passwordField}`}>
                <FaLock className={styles.icon} />
                <input
                  type={showConfirmPassword ? "text" : "password"}
                  placeholder="Confirm"
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  required
                />
                <span className={styles.eyeIcon} onClick={() => setShowConfirmPassword(!showConfirmPassword)}>
                  {showConfirmPassword ? <FaEyeSlash /> : <FaEye />}
                </span>
              </div>
            </div>

            <button type="submit" className={styles.signupBtn}>Create Free Account</button>
          </form>

          <p className={styles.loginText}>
            Already have an account? <a href="/login">Log in here</a>
          </p>
        </div>
        <p className={styles.footerNote}>Secure 256-bit SSL Encrypted Learning Platform</p>
      </div>
    </div>
  );
};

export default Signup;